module.exports = __webpack_public_path__ + "img/styria-digital-services.f00b538e.svg";